import { NgModule } from '@angular/core';
import { TruncatePipe } from './truncate.pipe';
/**
 * A module containing objects associated with the truncate pipe
 */
var TruncatePipeModule = /** @class */ (function () {
    function TruncatePipeModule() {
    }
    TruncatePipeModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        TruncatePipe
                    ],
                    exports: [
                        TruncatePipe
                    ]
                },] },
    ];
    /** @nocollapse */
    TruncatePipeModule.ctorParameters = function () { return []; };
    return TruncatePipeModule;
}());
export { TruncatePipeModule };
//# sourceMappingURL=truncate.pipe.module.js.map